import React from 'react';
import { IProductData, enCurrency } from 'interfaces/IProductData';
import Br from './Br';
import International from './International';
import { IStateBase, BaseComponent } from 'components/BaseComponent';
import { currencyService } from 'services/CurrencyService';

interface IPriceProps {
  cart: IProductData;
}

interface IState extends IStateBase {
  currency?: enCurrency;
}

export default class WithoutInstallment extends BaseComponent<IState, IPriceProps> {
  componentDidMount() {
    this.observeState({ currency: null }, currencyService.getCurrency());
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { currency } = this.state;

    return currency == enCurrency.BRL ? <Br cart={this.props.cart} /> : <International cart={this.props.cart} />;
  }
}
